
<!-- template for the modal component -->
<template>
  <transition name="modal">
    <div class="modal-mask modal-img-lobby initial-flights-modal"  role="dialog">
      <div class="modal-dialog" :class="modalClass" role="document">
        <div class="modal-content" v-click-outside="onClickOutside">

          <div class="modal-header pb-0">
            <slot name="header">
              <h4 class="modal-title">Default title</h4>
            </slot>
            <button type="button" class="btn" @click="$emit('close')">
              <img class="close-modal" :class="{'mb-4': !blackIcon}" :src="'https://comex.mints.cloud/public-assets/' + (blackIcon ? 'close-modal' : 'close-white')" alt="">
            </button>
          </div>

          <div class="modal-body pt-0 pb-0 px-0">
            <slot name="body">
              Default body
            </slot>
          </div>

          <div class="modal-footer w-100">
            <slot name="footer">
              <button type="button" class="btn btn-secondary" @click="$emit('close')">OK</button>
              <button type="button" class="buttons__button-continue" @click="$emit('close')"><i class="fal fa-times"></i> Close</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script nonce>
import vClickOutside from 'v-click-outside'

export default {
  props: {
    modalClass: {
      type: String
    },
    blackIcon: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  beforeMount() {
    document.body.style.overflow='hidden';
  },
  beforeUnmount() {
    document.body.style.overflow='';
  },
  methods: {
    onClickOutside (event) {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss">
.modal-mask.initial-flights-modal{
  background-color: rgba(0, 0, 0, 0.9) !important;
  font-size: 16px;
  .modal-content{
    background-color: white !important;
    padding: 0 clamp(15px, 3vw, 30px) 45px clamp(15px, 3vw, 30px) !important;
    margin: auto;
    align-items: flex-start !important;
    width: calc(100% - 30px) !important;
    max-width: 900px;
    top: 35px;
    .modal-header{
      top: 0 !important;
      position: relative !important;
      right: 0 !important;
      width: 100% !important;
      padding-inline: 0;
      .btn{
        border: 0;
      }
    }
    .modal-body{
      width: 100% !important;
    }
  }
}
.modal-title{
  font-weight: 700;
}
.modal-title.modal-color{
  color: #1e3b81;
  margin-bottom: 15px;
}
</style>

<style lang="scss" scoped>

.modal-content {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-bottom: 0 !important;
    //background: rgb(0,198,238);
    //background: linear-gradient(135deg, rgba(0,198,238,1) 0%, rgba(38,57,139,1) 100%);
    border: none;
}

.modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1060;
    background-color: rgba(0, 0, 0, .9);
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    overflow-y: auto;
}

.close-modal{
  width: 24px;
  height: 24px;
  object-fit: contain;
}

@media (min-width: 576px) {
  .modal-lg {
    width: 80%;
  }
  .modal-xl {
    width: 90%;
    max-width: 90% !important;
  }
}
.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
  height: 100%;
  top: 50%;
  z-index: 4;
}
</style>
